<template>
  <div id="app">
    <warningdlg>
      <el-button
        v-for="(item,index) in $store.state.warning.button"
        :key="index"
        :id="true?item.name:''"
        @click="item.callBack"
      >{{item.name}}</el-button>
    </warningdlg>
    <router-view v-if="isRouterAlive"/>
    <promotionListDlg/>
  </div>
</template>
<script>
import warningDlg from "./components/common/warningDlg";
import eventBus from "./eventbus";
import promotionListDlg from "./components/common/promotionListDlg";

export default {
  name: "app",
  data(){
     return {
        isRouterAlive: true  
     }
  },
  components: {
    warningdlg: warningDlg,
    promotionListDlg:promotionListDlg,
  },
  provide () {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。                                             
            return {
                reload: this.reload                                              
            }
        },
  methods: {
    warningBtn(data) {
      eventBus.$emit("warningBtn", data);
    },
    reload () {
                this.isRouterAlive = false;            //先关闭，
                this.$nextTick(function () {
                    this.isRouterAlive = true;         //再打开
                }) 
            }
  }
};
</script>

